import React, {useState, useEffect, useRef} from 'react';
import axios from 'axios';
import '../config.js';

import { alertService } from '../services/alert.service.js';
import { theme, createFormData } from '../services/helper.js';
import Progress from '../components/progress.js';

function Settings() {
  const [settings, setSettings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [key, setKey] = useState('');
  const [value, setValue] = useState('');

  useEffect(()=>{
    axios.get(global.config.api_server+'setting?token='+localStorage.getItem("token"))
    .then(res => {
      if(res.status === 200 && res.data.status === "success"){
        setSettings(res.data.settings);
        setLoading(false);
      }
    }).catch(err => {
      alertService.error(err);
    });
  }, []);

  const handleSubmit = (event) =>{
    event.preventDefault();
    if(key && value){
      axios.post(global.config.api_server+'setting',createFormData({
        key: key,
        value: value,
        token: localStorage.getItem("token")
      })).then(res => {
        if(res.status === 200 && res.data.status === "success"){
          alertService.success('Setting Updated');
          setTimeout(function(){
            window.location.reload();
          }, 1000);
        }else{
          alertService.error(res.data.error);
        }
      }).catch(err => {
        alertService.error(err);
      });
    }else{
      alertService.error('All the fields are required');
    }
  }

  let createSetting = "";
  if(parseInt(localStorage.getItem("role")) >= 5){
    createSetting = <a href="#" className={'btn btn-icon-split float-right btn-'+theme()} data-toggle="modal" data-target="#createModal">
                  <span className="icon text-white-50">
                    <i className="fas fa-image"></i>
                  </span>
                  <span className="text">Update Setting</span>
                </a>;
  }

  const keys = global.config.settings_token.split(",");

  return(
    <div className="container-fluid">
      {loading === true ? (
        <Progress label='Loading..'/>
      ):
      <div>
    <div className="card shadow mb-4">
      <div className="card-header py-3">
        {createSetting}
        <h6 className={'form-group mr-3 font-weight-bold text-'+theme()}>Settings <small>(Add 'null' for cancellation of setting)</small></h6>
      </div>
      <div className="card-body">
        <div className="table-responsive">
          <div className="row">
            <div className="col-sm-12">
              <table className="table table-bordered" width="100%">
                <thead>
                  <tr>
                    <th>Key</th>
                    <th>Value</th>
                  </tr>
                </thead>
                <tbody>
                  {settings.map(s =>
                    <tr key={s.token}>
                      <td>{s.token}</td>
                      <td>{s.value}</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="modal fade" id="createModal" tabIndex="-1" role="dialog" aria-labelledby="create-popup" aria-hidden="true">
        <div className="modal-dialog modal-xl" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="create-popup">Update Setting</h5>
              <button className="close" type="button" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <form>
              <div className="modal-body">
                <div className="form-group">
                  <label>Key</label>
                  <select name="key" className="form-control" onChange={(e) => setKey(e.target.value)}>
                    {keys.map(d =>
                      <option value={d} key={d}>{d}</option>
                    )}
                  </select>
                </div>
                <div className="form-group">
                  <label>Value</label>
                  <textarea value={value} maxLength="500" name="value" className="form-control" id="value" placeholder="Enter value" onChange={(e) => setValue(e.target.value)}></textarea>
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-default" type="reset" data-dismiss="modal">Close</button>
                <button className={'btn btn-'+theme()} type="button" onClick={handleSubmit}>Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    }
    </div>
  )
}

export default Settings;